// extracted by css-extract-rspack-plugin
export default {"extendingConnector":"extendingConnector-IMeOqA","compact":"compact-EdPnRm","connectorLine":"connectorLine-JURYEf","addButton":"addButton-wZOmOh"};